export default __webpack_public_path__ + "static/parallaxbanner-7860cc20c12afec49e839a9a48f89cc4.png";